var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"340px"},attrs:{"id":"chartsGraphTwo"}},[(!_vm.isShowLoad)?_c('div',{attrs:{"id":"charts-graph"}}):_c('div',{staticClass:"graph-loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }